var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"livestream-new-component"},[_c('LivestreamForm',{attrs:{"livestream":_vm.livestream,"submitButtonLabel":'Create',"platforms":_vm.platforms},on:{"handle-form-submit":_vm.createLivestream}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }